import React from "react";
import PacmanLoader from "react-spinners/PacmanLoader";

const override = {
  display: "block",
  margin: "20px auto",
  borderColor: "red",
};

class LoadingSpinner extends React.Component {
  render() {
    return <PacmanLoader color={"#37B44E"} css={override} />;
  }
}

export default LoadingSpinner;
